import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { FC, useEffect } from "react";
import { connect } from "react-redux";

export interface OneTrustScriptProps {
    oneTrustId?: any;
}

const scriptTagAutoBlock = (id: string) => {
    const script = document.createElement("script");

    script.type = "text/javascript";
    script.src = `https://cdn.cookielaw.org/consent/${id}/OtAutoBlock.js`;

    document.head.appendChild(script);
};

const scriptTagOneTrust = (id: string): void => {
    const script = document.createElement("script");

    script.type = "text/javascript";
    script.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
    script.charset = "UTF-8";
    script.setAttribute("data-document-language", "true");
    script.setAttribute("data-domain-script", id);

    document.head.appendChild(script);
};

const scriptTagExecuteOptAnon = (): void => {
    const script = document.createElement("script");

    script.type = "text/javascript";
    script.innerText = "function OptanonWrapper() {}";

    document.head.appendChild(script);
};

const mapStateToProps = (state: ApplicationState) => {
    const thirdPartyScriptSettings: any = getSettingsCollection(state).thirdPartyScriptSettings;
    return {
        thirdPartyScriptSettings,
    };
};

type Props = OneTrustScriptProps & ReturnType<typeof mapStateToProps>;

const OneTrustScript: FC<Props> = ({ thirdPartyScriptSettings, oneTrustId }) => {
    oneTrustId = thirdPartyScriptSettings?.oneTrustScriptId;

    useEffect(() => {
        if (oneTrustId) {
            scriptTagAutoBlock(oneTrustId);
            scriptTagOneTrust(oneTrustId);
            scriptTagExecuteOptAnon();
        }
    }, [oneTrustId]);

    return null;
};

export default connect(mapStateToProps)(OneTrustScript);
